import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { IDatePickerConfig } from 'ng2-date-picker';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { CreditSit } from 'src/app/shared/models/creditSit.model';
import { Dealer } from 'src/app/shared/models/dealer.model';
import { Manager } from 'src/app/shared/models/manager.model';
import { RequestFilter } from 'src/app/shared/models/RequestFilter.model';
import { Status } from 'src/app/shared/models/status.model';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';
import { RequestService } from 'src/app/shared/services/core/request.service';
import { StatusService } from 'src/app/shared/services/core/status.service';
import { DealersFofComponent } from '../cadastros/dealers-fof/dealers-fof.component';
import { DealerService } from 'src/app/shared/services/core/dealer.service';
import { CreditService } from 'src/app/shared/services/core/credit.service';
import { ManagerService } from 'src/app/shared/services/core/manager.service';
import { Request } from 'src/app/shared/models/request.model';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';

@Component({
  selector: 'app-solicitacoes',
  imports: [TegelModule, CommonModule],
  templateUrl: './solicitacoes.component.html',
  styleUrl: './solicitacoes.component.scss'
})
export class SolicitacoesComponent implements OnInit {
  frontOffices!: any[];
  dealers!: Dealer[];
  row: Request;
  managers!: Manager[];
  credits: CreditSit[] = [];
  request: Request[] = [];
  requestFilter: RequestFilter;
  status!: Status[];
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";
  tabIndex = 0;

  dateConfigPeriodFrom: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  }

  dateConfigUpTo: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  }

  constructor(
    private dialogService: DialogService,
    private utilService: UtilService,
    private frontOfficesService: FrontOfficesService,
    private requestService: RequestService,
    private statusService: StatusService,
    private dealerService: DealerService,
    private creditService: CreditService,
    private managerService: ManagerService,
    private toastrService: ToastrService
  ) {
    this.row = new Request();
    this.requestFilter = new RequestFilter();
    this.request = [];
    this.frontOfficesService.get().subscribe((result) => {
      if (result) {
        this.frontOffices = result;
      }
    });
    this.dealerService.get().subscribe((result) => {
      if (result) {
        this.dealers = result;
      }
    });
    this.statusService.get().subscribe((result) => {
      if (result) {
        this.status = result;
      }
    });
    this.managerService.getActive().subscribe((result) => {
      if (result) {
        this.managers = result;
      }
    });
    this.creditService.getCreditSit().subscribe((result) => {
      if (result) {
        this.credits = result;
      }
    });
  }

  ngOnInit(): void {  }

  setActiveTab(index: number){
    this.tabIndex = index;
  }

  // chooseClient() {
  //   this.dialogService.addDialog(ClientComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.client != null) {
  //       const client = result.client;
  //       this.requestFilter.clientId = client.id;
  //       this.requestFilter.corporateName = client.corporateName;
  //     }
  //   });
  // }

  getAll(page: number) {
    this.row = new Request();
    this.requestService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.requestFilter).subscribe((result) => {
      this.request = result.page;
      this.page = result.currentPage;
      this.total = result.totalPages;
    });
  }

  changeDateFrom(value: any) {
    this.dateConfigUpTo.min = value;
    this.dateConfigUpTo = { ...this.dateConfigUpTo };
  }

  changeDateTo(value: any) {
    this.dateConfigPeriodFrom.max = value;
    this.dateConfigPeriodFrom = { ...this.dateConfigPeriodFrom };
  }

  changeAuthorizedToConfirm(ev: any) {
    this.requestFilter.authorizedToConfirm = ev.target.checked;
  }

  search() {
    this.getAll(1);
  }

  resetFilters() {
    this.requestFilter = new RequestFilter();
    this.changeDateFrom(null);
    this.changeDateTo(null);
  }

  selectedRequest(request: Request){
    this.row = request;
  }

  exportFile() {
    this.requestService.generateFile(this.requestFilter);
  }

  deleteRequest(cod: any) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir a solicitação ' + cod + '?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.requestService.delete(cod).subscribe((result) => {
          if (result && !result.hasErrors){
            let index = 0;
            do {
              index = this.request.findIndex(c => c.id === cod);
              if (index > -1) {
                this.request.splice(index, 1);
              }
            } while (index != -1);

            this.toastrService.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  // openSaveRequest() {
  //   this.dialogService.addDialog(AddRequestComponent,{},this.utilService.getModalOptions()).subscribe((result) => {
  //   });
  // }


}
